module.exports = __webpack_public_path__ + "static/07-acadia-2a40170ad00b5bde28e11bd4a6f702e1.jpg";